import { SubscriptionType } from '../enums/subscriptionType';
import { useAppSelector } from './redux';

export const useSubcriptionType = () => {
  const account = useAppSelector((x) => x.app.account);
  const isAccountSelect = () => account?.subscriptionStatus?.current === SubscriptionType.SELLWITH_SELECT;
  const isAccountPro = () =>
    account?.subscriptionStatus?.current === SubscriptionType.SELLWITH_PRO ||
    account?.subscriptionStatus?.current === SubscriptionType.SELLWITH_PRO_UK;
  const isAccountInTier = (allowedTiers: SubscriptionType[]) =>
    account?.subscriptionStatus?.current && allowedTiers.includes(account.subscriptionStatus.current);
  const isAccountTrial = () => account?.subscriptionStatus?.current?.endsWith('trial');
  return { isAccountPro, isAccountSelect, isAccountInTier, isAccountTrial };
};
